import {
  COMISSIONS_LIST,
  DELETE_COMMISSION,
  GET_PROMOCODE_BY_ID,
  GET_SUBADMIN_BY_ID,
  UPDATE_PROMOCODE,
  UPDATE_SYSTEM_ACCESS_STATUS,
} from "./ApiCalls";

export default {
  BASE_URL: "https://api.somosblossom.com",
  API_URL: "https://api.somosblossom.com/authenticationservice/api/v1",

  // ADMIN
  LOGIN_ADMIN: "/store/login",
  FORGET_PASSWORD_ADMIN: "/store/forgotpassword",
  RESET_PASSWORD: "/user/resetpassword",
  CHANGE_PASSWORD: "/store/changepassword",
  ADMIN_UPDATE: "admin/editAdmin",
  GET_PROFILE: "/store/me",
  UPDATE_PROFILE: "/store/updateprofile",

  // UPLOAD FILE

  UPLOAD_FILE: "/file/add",

  //DASHBOARD

  DASHBOARD_DATA: "/store/reports/dashboard",

  // help

  HELP_LIST: "/dispute",

  // accounting

  ACCOUNTING_LIST: "/accounting",

  // ADD USER
  ADD_USER: "/store/adduser",
  USER_LIST: "/store/users",
  GET_USER_BY_ID: "/store/user/",
  UPDATE_USER: "/store/updateuser",
  DELETE_USER: "/store/removeuser",
  USER_STATUS_CHANGE: "/store/user/updatestatus/all",
  USER_IMPORT_BY_CSV: "/store/importUserViaCSV",
  EXPORT_USER_CSV: "/store/export/users",
  DOCUMENT_STATUS:"/store/updateDocumentStatus",
  // service provider
  SERVICE_PROVIDERS_LIST: "/store/vendors",
  SERVICE_PROVIDER_VIEW: "/store/vendor/view/",
  ADD_SERVICE_PROVIDER: "/store/addvendor",
  UPDATE_SERVICE_PROVIDER: "store/updatevendor",
  DELETE_PROVIDER: "/store/archivevendor",
  STATUS_CHANGE_SERVICE_PROVIDER: "/store/vendors/updatestatus/all",
  SERVICE_PROVIDER_IMPORT_BY_CSV: "store/importVendorViaCSV",
  EXPORT_SERVICE_PROVIDER_CSV: "/store/export/vendors",
  EXPORT_REPORTED_CSV:"/store/export/reportedVendors",

  // earning report

  GET_EARNING_REPORT: "store/reports/orders",

  // service category

  SERVICE_CATEGORY_LIST: "/category/viewallcategory",
  ADD_SERVICE_CATEGORY: "/category/add",
  UPDATE_SERVICE_CATEGORY: "/category/update",
  DELETE_SERVICE_CATEGORY: "/category/remove",
  VIEW_SERVICE_CATEGORY: "/category/view/",

  // subscription
  GET_SUBSCRIPTION: "/store/plan",
  ADD_SUBSCRIPTION: "/store/plan/add",
  VIEW_SUBSCRIPTION: "/store/plan/view/",
  EDIT_SUBSCRIPTION: "/store/plan/update/",
  DELETE_SUBSCRIPTION: "/store/plan/remove/",
  GET_SUBSCRIPTION_SUBSCRIBER: "/store/Subscriptions",

  // content page
  ADD_CONTENT: "/content/add",
  CONTENT_VIEW: "/content/view/",
  CONTENT_UPDATE: "/content/update",
  CONTENT_STATUS_CHANGE: "/content/updatestatus/all",
  CONTENT_DELETE: "/content/remove",
  CONTENT_LIST: "/content",

  // faw
  ADD_FAQ: "/faq/add",
  FAQ_VIEW: "/faq/view/",
  FAQ_UPDATE: "/faq/update",
  FAQ_STATUS_CHANGE: "/faq/updatestatus/all",
  FAQ_DELETE: "/faq/remove",
  FAQ_LIST: "/faq",
  VIEW_SERVICE_CATEGORY: "/category/view/",

  // singup questions
  SIGNUP_QUESTION_LIST: "/questions/listSignupQue",
  SIGNUP_QUESTION_ADD: "/questions/addSignupQue",
  SIGNUP_QUESTION_UPDATE: "/questions/updateSignupQue",
  SIGNUP_QUESTION_DELETE: "/questions/removeSignupQue",
  SIGNUPQUESTION_DETAIL: "/questions/viewSignupQue/",
  // Category Request
  CATEGORY_REQUEST_LIST: "/categoryRequests/getCategoriesRequests",
  GET_VENDORTHRAPIST: "/categoryRequests/listVendorTherapists",
  ACCEPT_CATEGORY_REQUEST: "/categoryRequests/acceptCategoryRequest",
  REASSIGN_CATEGORY_REQUEST: "/categoryRequests/updateCategoryRequest",
  REJECT_CATEGORY_REQUEST: "/categoryRequests/rejectCategoryRequest",

  // Manage Promocode
  ADD_PROMOCODE: "/promoCode/add",
  PROMOCODE_LIST: "/promoCode/",
  UPDATE_PROMOCODE: "/promoCode/update",
  DELETE_PROMOCODE: "/promoCode/remove",
  GET_PROMOCODE_BY_ID: "/promoCode/view/",
  PROMOCODE_STATUS_CHANGE: "/promoCode/updatestatus/all",
  // Add Report
  ADD_REPORT: "/notice/add",
  UPDATE_REPORT: "/notice/update",
  REPORT_LIST: "/notice",
  DELETE_REPORT: "/notice/delete",
  GET_REPORT_BY_ID: "/notice/view/",

  //------------------
  ADD_SUB_ADMIN: "/store/addSubadmin",
  UPDATE_SUB_ADMIN: "/store/updateSubadmin",
  SUBADMINS_LIST: "/store/subadmin",
  DELETE_SUBADMIN: "/store/removeSubadmin",
  GET_SUBADMIN_BY_ID: "store/subadmin/",
  UPDATE_SYSTEM_ACCESS_STATUS: "/store/subadmin/updatestatus/all",

  // Order management
  GET_ORDER: "/store/orders",
  VIEW_ORDER: "/store/order/",
  GET_REPORTED_USERS: "/store/listUserReports",

  //  Manage Commissions
  COMMISSIONS_LIST: "/category/viewallcategory", // change it after got the api
  DELETE_COMMISSION: "/category/remove", //here as well
  SET_COMMISSION: "category/update",
  UPDATE_DISPUTE: "/dispute/update",

  ADD_PROMOTION: "/promotion/add",
  PROMOTION_LIST: "/promotion/",
  UPDATE_PROMOTION: "/promotion/update",
  DELETE_PROMOTION: "/promotion/remove",
  GET_PROMOTION_BY_ID: "/promotion/view/",

  CONFIG_DATA: "/store/configs/",
  BASIC_SETTING: "/setting/getstoresetting",
  UPDATE_BASIC_SETTING: "/setting/storesetting",

  // Notification
  ADD_NOTIFICATION: "/notificationTemplate/add",
  NOTIFICATION_VIEW: "/notificationTemplate/view/",
  NOTIFICATION_UPDATE: "/notificationTemplate/update",
  NOTIFICATION_STATUS_CHANGE: "/notificationTemplate/updatestatus/all",
  NOTIFICATION_DELETE: "/notificationTemplate/remove",
  NOTIFICATION_LIST: "/notificationTemplate",
  REFUND_LIST: "/store/refund/list",
  EXPORT_HELP_CSV: "/store/export/dispute",
  // service

  SERVICE_LIST: "/service/list",
  ADD_SERVICE: "/service/add",
  UPDATE_SERVICE: "/service/update",
  DELETE_SERVICE: "/service/remove",
  VIEW_SERVICE: "/service/view/",

  QUESTION_LIST: "/questions/list",
  ADD_QUESTION: "/questions/add",
  UPDATE_QUESTION: "/questions/update",
  DELETE_QUESTION: "/questions/remove",
  VIEW_QUESTION: "/questions/view/",
  GET_CATEGORY_REQUEST: "/categoryRequests/viewCategoryRequest",


};
